module.exports = __webpack_public_path__ + "static/android-icon-192x192-a74f22a8b7346d0857e95ace9a36830c.png";